import React from "react";
import Header from "../../../../ui-components/LandingPage/BulkUi/Header";
import Testimonial from "../../../../ui-components/LandingPage/BulkUi/Testimonial";
import TestimonialOne from "../../../../ui-components/LandingPage/BulkUi/TestimonialOne";
// import SearchApi from "../../../../ui-components/LandingPage/BulkUi/SearchApi";
import Card1 from "../../../../ui-components/LandingPage/BulkUi/Card1";
import Card2 from "../../../../ui-components/LandingPage/BulkUi/Card2";

const Api = () => {
  return (
    <>
      {/* <div className="min-[2000px]:px-36"> */}
      <Header />
      <Card1 />
      <Testimonial />
      <Card2 />
      <TestimonialOne />
      {/* <SearchApi /> */}
      {/* </div> */}
    </>
  );
};

export default Api;